import React from "react";
import { Form, Input, Space } from "antd";
import StepHeader from "../../Evaluation/StepHeader";

const { TextArea } = Input;

interface TestRunDescriptionProps {
  description?: string;
  onChange: (description: string) => void;
}

const TestRunDescription: React.FC<TestRunDescriptionProps> = ({
  description,
  onChange,
}) => {
  return (
    <Space 
      direction="vertical" 
      size="large" 
      style={{width: "100%"}}
    >
      <StepHeader
        title="Test Run Details"
        description="Enter a description for your test run"
              />
      
      <Form layout="vertical" style={{ width: "100%" }}>
        <Form.Item
          label="Description"
          required
          tooltip="Provide a description of this test run"
        >
          <TextArea
            rows={4}
            value={description}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Enter test run description"
          />
        </Form.Item>
      </Form>
    </Space>
  );
};

export default TestRunDescription;
